import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'msFormatPhoneNumber',
    standalone: true,
})
export class FormatPhoneNumberPipe implements PipeTransform {
    MOBILE_NUMBER_MATCHER = /^(\d{3})(\d{3})(\d{4})$/;

    transform(value: string): string {
        const cleaned = value.replace(/\D/g, '');
        const match = cleaned.match(this.MOBILE_NUMBER_MATCHER);

        if (match?.length) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }

        return value;
    }
}
